import { createApiSlice } from "@common";
import { CRUD_SALES_PRIORITY } from "@routes";

const apiConfig = [
  {
    name: "addCrmPriority",
    method: "post",
    url: CRUD_SALES_PRIORITY,
    stateKey: "message",
  },
  {
    name: "getCrmPriority",
    method: "get",
    url: CRUD_SALES_PRIORITY,
    stateKey: "data",
  },
  {
    name: "updateCrmPriority",
    method: "put",
    url: CRUD_SALES_PRIORITY,
    stateKey: "message",
  },
  {
    name: "deleteCrmPriority",
    method: "delete",
    url: CRUD_SALES_PRIORITY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "crmPriority",
  apiConfig,
  customReducers);
const crmPrioritySlice = slice;

export default crmPrioritySlice.reducer;

export const {
  addCrmPriority,
  getCrmPriority,
  updateCrmPriority,
  deleteCrmPriority,
} = thunks;

export const { rowSelect } = actions;
